import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { FlightPalets } from '../containers';

export const FlightPaletsPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  return <FlightPalets id={id} />;
};
